











import { Component, Vue } from "vue-property-decorator";
import ConstructionEdit from "../components/ConstructionEdit.vue";
import { getConstruction, saveConstruction } from "../../api/construction-api";
import createConstructionOutput from "../../models/factories/createConstructionOutput";
import ConstructionFormData from "../../models/factories/ConstructionFormData";

@Component({
  components: {
    ConstructionEdit
  }
})
export default class ConstructionNewPage extends Vue {
  construction = createConstructionOutput();

  // get taskTypeOptions(): SelectOption[] {
  //   return this.taskTypes.map(c => ({
  //     text: c.name,
  //     value: c.taskTypeId
  //   }));
  // }

  private async initConstruction() {
    this.construction = await getConstruction();
  }

  private created() {
    // this.initConstruction();
  }

  async ok() {
    await this.save();
    this.goListPage();
  }

  private async save() {
    if (!this.construction) return;
    const d = ConstructionFormData(this.construction);
    await saveConstruction(d);
  }

  cancel() {
    this.goListPage();
  }

  private goListPage() {
    this.$router.push({ name: "construction-list" });
  }
}
